import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=21e4b6bf&scoped=true&"
import script from "./MediaPreview.vue?vue&type=script&lang=ts&"
export * from "./MediaPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&id=21e4b6bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e4b6bf",
  null
  
)

export default component.exports